import * as React from 'react';
import { components, OptionProps } from 'react-select';
import { SelectionOption } from '../../Types';

const sanitizeValue = (value: string | number | null | undefined): string =>
  String(value || 'undefined').replace(/[^a-zA-Z0-9-_]/g, '');

const buildIntercomTarget = (base: string, value: unknown): string => {
  const safeValue = sanitizeValue(value as string | number | null | undefined);
  return `${base}-option-${safeValue}`;
};

export const createCustomOption = (dataIntercomTarget?: string) =>
  React.memo<OptionProps<SelectionOption>>((props) => (
    <div
      {...(dataIntercomTarget && {
        'data-intercom-target': buildIntercomTarget(dataIntercomTarget, props.data.value),
      })}
    >
      <components.Option {...props} />
    </div>
  ));

export default createCustomOption;
